import { formatDateTime, formatYearMonth } from '@/shared/lib/dateFormat';

/** YYYYMM → 표시용 문자열 */
export const formatRefYm = (refYm?: string | null): string =>
  formatYearMonth(refYm);

/** 히스토리 테이블 등 — `YYYY.MM` */
export const formatRefYmDot = (refYm?: string | null): string =>
  formatYearMonth(refYm);

/** 현재 월 YYYYMM */
export const getCurrentRefYm = (): string => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  return `${y}${m}`;
};

export const mapFeeTypeLabel = (feeType?: string): string => {
  if (feeType === 'RANGE') return '구간';
  if (feeType === 'FIXED') return '고정';
  return '-';
};

export const formatAmount = (value?: number | null): string => {
  if (value == null || Number.isNaN(Number(value))) return '-';
  return `${Number(value).toLocaleString()}원`;
};

/** 목록·읽기 전용 수수료율 — 레거시 InputNumber precision={2}와 동일하게 소수점 2자리 */
export const formatRate = (value?: number | null): string => {
  if (value == null || Number.isNaN(Number(value))) return '-';
  return `${Number(value).toFixed(2)}%`;
};

/** 입력란 비포커스 시 표시용 (예: 5 → "5.00") */
export const formatRateInput = (value?: number | null): string => {
  if (value == null || Number.isNaN(Number(value))) return '';
  return Number(value).toFixed(2);
};

/** 수수료율 0~100, 소수점 2자리로 반올림 */
export const roundRate = (value: number): number =>
  Number(Math.min(100, Math.max(0, value || 0)).toFixed(2));

/**
 * 상세 수수료율 -100~100, 소수점 2자리로 반올림.
 * 상세 수수료는 기본 수수료에서 차감하는 마이너스 값도 허용한다 (서버도 부호 제한 없음).
 */
export const roundSignedRate = (value: number): number =>
  Number(Math.min(100, Math.max(-100, value || 0)).toFixed(2));

/** 레거시 formatDateTime — RDS 표시 포맷 */
export const formatFeeDateTime = formatDateTime;

/** policy 설정 시각 — updatedAt(레거시) 또는 configuredAt */
export const getBasicFeePolicyConfiguredAt = (policy?: {
  updatedAt?: string | null;
  configuredAt?: string | null;
} | null): string | null =>
  policy?.updatedAt ?? policy?.configuredAt ?? null;
